import { Button, type ButtonProps } from "@rescuetablet/theme";
import { ReactNode } from "react";

export type Props = Omit<ButtonProps, "startIcon" | "endIcon"> & {
  icon?: ReactNode;
  loading?: boolean;
};

export default function SubmitButton({
  icon,
  loading,
  disabled,
  ...props
}: Props) {
  return (
    <Button
      variant="contained"
      color="secondary"
      type="submit"
      loading={loading}
      loadingPosition={icon ? "start" : "center"}
      startIcon={icon}
      disabled={disabled}
      {...props}
    />
  );
}
